module.exports = __webpack_public_path__ + "media/images/pic/saska/teddy-2a42b6818eeee6e7eb30488b9c8daa76.svg";